import { yup } from '@/libs/yup';
import { FileType } from '@/types';

const itemSchema = yup
  .object({
    checked: yup.string().notRequired().oneOf(['true', 'false']).label('実施有無'),
    value: yup.string().notRequired().max(100).label('結果'),
    evaluation: yup.string().notRequired().max(100).label('評価'),
    hasFinding: yup.string().notRequired().oneOf(['true', 'false']).label('所見有無')
  })
  .optional();

export const schema = yup.object({
  dateOn: yup.string().dateFormat().required().label('実施年月日'),
  orderByDoctor: yup.string().nullable().oneOf(['true', 'false']).label('医師の指示対象'),
  report: yup.mixed<File | FileType>().fileSize().nullable().label('健康診断結果ファイル'),
  officeId: yup.string().nullable().label('適用事業所'),
  healthCheckupInstitutionId: yup.string().nullable().label('健康診断実施機関'),
  specifiedWorkCode: yup
    .array(yup.string().required())
    .required()
    .label('労働安全衛生規則第13条第１項第３号に掲げる業務'),
  items: yup.object({
    medicalHistory: itemSchema,
    symptoms: itemSchema,
    height: itemSchema,
    weight: itemSchema,
    abdominalCircumference: itemSchema,
    visionRight: itemSchema,
    visionLeft: itemSchema,
    hearing1000Hz: itemSchema,
    hearing1000HzRight: itemSchema,
    hearing1000HzLeft: itemSchema,
    hearing4000Hz: itemSchema,
    hearing4000HzRight: itemSchema,
    hearing4000HzLeft: itemSchema,
    hearingOther: itemSchema,
    hearingOtherRight: itemSchema,
    hearingOtherLeft: itemSchema,
    chestXRay: itemSchema,
    sputumTest: itemSchema,
    bloodPressure: itemSchema,
    anemiaTest: itemSchema,
    liverFunctionTest: itemSchema,
    bloodLipidTest: itemSchema,
    bloodSugarTest: itemSchema,
    urineSugar: itemSchema,
    urineProtein: itemSchema,
    electrocardiogram: itemSchema
  })
});

export type Schema = yup.InferType<typeof schema>;

export const defaultValues = {
  officeId: null,
  healthCheckupInstitutionId: null,
  dateOn: '',
  orderByDoctor: 'false',
  report: null,
  specifiedWorkCode: [],
  items: {
    medicalHistory: { checked: 'true', hasFinding: 'false' },
    symptoms: { checked: 'true', hasFinding: 'false' },
    height: { checked: 'true', hasFinding: 'false' },
    weight: { checked: 'true', hasFinding: 'false' },
    abdominalCircumference: { checked: 'true', hasFinding: 'false' },
    visionRight: { checked: 'true', hasFinding: 'false' },
    visionLeft: { checked: 'true', hasFinding: 'false' },
    hearing1000Hz: { checked: 'true', hasFinding: 'false' },
    hearing1000HzRight: { checked: 'true', hasFinding: 'false' },
    hearing1000HzLeft: { checked: 'true', hasFinding: 'false' },
    hearing4000Hz: { checked: 'true', hasFinding: 'false' },
    hearing4000HzRight: { checked: 'true', hasFinding: 'false' },
    hearing4000HzLeft: { checked: 'true', hasFinding: 'false' },
    hearingOther: { checked: 'true', hasFinding: 'false' },
    hearingOtherRight: { checked: 'true', hasFinding: 'false' },
    hearingOtherLeft: { checked: 'true', hasFinding: 'false' },
    chestXRay: { checked: 'true', hasFinding: 'false' },
    sputumTest: { checked: 'true', hasFinding: 'false' },
    bloodPressure: { checked: 'true', hasFinding: 'false' },
    anemiaTest: { checked: 'true', hasFinding: 'false' },
    liverFunctionTest: { checked: 'true', hasFinding: 'false' },
    bloodLipidTest: { checked: 'true', hasFinding: 'false' },
    bloodSugarTest: { checked: 'true', hasFinding: 'false' },
    urineSugar: { checked: 'true', hasFinding: 'false' },
    urineProtein: { checked: 'true', hasFinding: 'false' },
    electrocardiogram: { checked: 'true', hasFinding: 'false' }
  }
} satisfies Schema;
